// extracted by mini-css-extract-plugin
export default {"job":"ddNw7k3gmubVFbPzMW5d","title":"fjEWVM3LlXlfiZTJFpRd","buttonsBlock":"qyrwuhj9WSWLEG3hxZnq","button":"x7iTaAl2pIPlxljwJEeS"};